var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "line-chart",
    d: "M3.688-5.312l-.375-.375a.43.43,0,0,1,0-.687L5.656-8.719a.43.43,0,0,1,.688,0L9-6.062l2.75-2.75-.937-.906a.7.7,0,0,1-.156-.812A.685.685,0,0,1,11.344-11H14.5a.487.487,0,0,1,.359.141A.487.487,0,0,1,15-10.5v3.156a.685.685,0,0,1-.469.688.7.7,0,0,1-.812-.156l-.906-.937L9.344-4.281a.43.43,0,0,1-.687,0L6-6.937,4.375-5.312A.43.43,0,0,1,3.688-5.312ZM15.5-1.5a.487.487,0,0,1,.359.141A.487.487,0,0,1,16-1v.5a.487.487,0,0,1-.141.359A.487.487,0,0,1,15.5,0H1A.961.961,0,0,1,.3-.3.961.961,0,0,1,0-1V-11.5a.487.487,0,0,1,.141-.359A.487.487,0,0,1,.5-12H1a.487.487,0,0,1,.359.141A.487.487,0,0,1,1.5-11.5v10Z",
    transform: "translate(0 12)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChart);
export default __webpack_public_path__ + "static/media/line-chart.e16f7f1824d5e6f961d7bf507d68b612.svg";
export { ForwardRef as ReactComponent };